/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetProductPlans = () => useApi(`/v2/product-plan/products`, 'GET', {}, {}, true);

export const useProductPlanClone = (idProductPlan) => useApi(`v2/product-plan/${idProductPlan}/clone`, 'POST', {}, {});

export const useProductPlanExpire  = (idProductPlan) => useApi(`v2/product-plan/${idProductPlan}/expire`, 'DELETE', {}, {});

export const useProductPlanRestore  = (idProductPlan) => useApi(`v2/product-plan/${idProductPlan}/restore`, 'PATCH', {}, {});

export const useGetProductPlanVigencyParamsSync = () => useApi(
  `/v2/product-plan/vigency-params`,
  'GET',
  {},
  {},
  true
);
